import { render, staticRenderFns } from "./GroupTable.vue?vue&type=template&id=ae637ff8"
import script from "./GroupTable.vue?vue&type=script&lang=ts"
export * from "./GroupTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports